import request from '@/util/request';

// 分页列表
export const getPageListApi = (params, options) =>
  request.get('/api/v4ward/prePay/electricity/meter/page', Object.assign({}, options, { params }));

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/prePay/electricity/meter/save', params, options, {
    'Content-Type': 'application/json',
  });

// 编辑
export const updateApi = (params, options) =>
  request.post('/api/v4ward/prePay/electricity/meter/revise', params, options, {
    'Content-Type': 'application/json',
  });

// 日志列表
export const getLogListApi = (params, options) =>
  request.get(
    '/api/v4ward/prePay/electricity/meter/reviseLogPage',
    Object.assign({}, options, { params })
  );

// 扣缴
export const withholdApi = (params, options) =>
  request.post('/api/v4ward/prePay/electricity/meter/meterReduce', params, options, {
    'Content-Type': 'application/json',
  });

// 充值
export const rechargeApi = (params, options) =>
  request.post('/api/v4ward/prePay/electricity/meter/meterCharge', params, options, {
    'Content-Type': 'application/json',
  });
